/**
 * Voice support detection — mirrors the backend VOICE_LOCALE_MAP. Kept
 * inline rather than imported from @tendedloop/shared because the locale
 * set is tiny and unlikely to drift; if it ever does, lift it into shared.
 *
 * Yiddish (yi) is intentionally absent — Google STT V2 doesn't support it,
 * so the mic button must be hidden on Yiddish UIs.
 */
const VOICE_SUPPORTED_LOCALES = new Set(['en', 'he', 'ar', 'es', 'fr', 'de', 'pt-BR', 'it', 'ru', 'am', 'ja']);

export function isVoiceSupportedInBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof MediaRecorder === 'undefined') return false;
  if (!navigator.mediaDevices?.getUserMedia) return false;
  return true;
}

export function isLocaleSupportedForVoice(locale: string | undefined): boolean {
  if (!locale) return false;
  if (VOICE_SUPPORTED_LOCALES.has(locale)) return true;
  const base = locale.split('-')[0];
  return !!base && VOICE_SUPPORTED_LOCALES.has(base);
}
